// @ts-nocheck
// this file was patched by @terra

import { z } from 'zod';

export const PreventionControlTypeSchema = z.enum(['waf','network','config','ips'] as const);

export type PreventionControlTypeType = `${z.infer<typeof PreventionControlTypeSchema>}`

export default PreventionControlTypeSchema;
